import React, { useEffect, useState } from 'react';
import "./EditUserProfile.css";
import Header from "../components/Header";
import deleteIcon from "../../assets/icons/delete.svg";
import eyeIcon from "../../assets/icons/eye.svg";
import useAuth from '../../customHooks/useAuth';
import { countryCodeList } from '../../data';
import { useNavigate,useLocation } from 'react-router-dom';
import ImageLoader from '../../assets/ImageLoader/ImageLoader.jsx';
import axios from 'axios';
import { toast } from 'react-toastify';
import PageLoader from '../../assets/pageLoader/PageLoader.js';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import { baseUrl } from '../../common/baseUrl';
import axiosInstance from '../../axiosInstance/axiosInstance.js';
import Dropdown from "../components/Dropdown/Dropdown";
 
// demo
// import aadhar from "../../assets/aadharID.jpeg";

export default function EditUserProfile() {


    const navigate = useNavigate();
    const location = useLocation();

    const name = location.state?.name || "";
    const email = location.state?.email || "";
    const phone = location.state?.phone || "";
    const address = location.state?.address || "";
    const verification_id = location.state?.verification_id || "";
    const phoneString = String(phone).slice(2); // Convert to string and skip the first 2 characters


    const userId = localStorage.getItem("user_id");
    const [showImageModal, setShowImageModal] = useState(false); // State to show/hide the modal
    const [imageurl,setImageUrl] = useState(""); // Image Url

    const [urlId1,setUrlId1] = useState("");
    const [urlId2,setUrlId2] = useState("");

    const [imageModal1,setImageModal1] = useState(false);
    const [imageModal2,setImageModal2] = useState(false);

    // Loading
    const [loading,setLoading] = useState(false);

    // Skelton Load For MinatureImage
    const [miniImgLoad,setMiniImgLoad] = useState(false);
    const [miniImgLoad1,setMiniImgLoad1] = useState(false);
    const [miniImgLoad2,setMiniImgLoad2] = useState(false);

    // Refresh handle
    useAuth();


    // Errors Handling
    const [errors,setErrors] = useState({});

    // Form Data Handling
    const [formData,setFormData] = useState({
        name : "" || name,
        email : "" || email,
        address : "" || address,
        countryCode : "+91",
        fileName : "" || verification_id ,
        phone : "" || phoneString,
        file : null,
        imageKey : null,
        filePreview : "",

        veri_id1 : "",
        veri_id2 : "",

        file1 : null,
        filePreviewId1 : "",
        imageKeyId1 : "",

        file2 : null,
        filePreviewId2 : "",
        imageKeyId2 : "",
    
    });


    // Divide the ID's with comma for multiple ID's
    useEffect(()=>{
        const checkWithId = ()=>{
            try{
                if(verification_id.includes(",")){
                    const ids = verification_id.split(",");
                    // console.log("ID's Data : ",ids);
                    setFormData((prev)=>({
                        ...prev,
                        fileName : ids[0] || "",
                        veri_id1 : ids[0] || "",
                        veri_id2 : ids[1] || ""
                    }))
                }
                else{
                    setFormData((prev)=>({
                        ...prev,
                        fileName : verification_id || "",
                        veri_id1 : verification_id || "",
                        veri_id2 : ""
                    }))
                }
            }catch(error){
                console.log(error);
            }
        }
        checkWithId();
    },[])

    // console.log("ID 1 : ",formData.veri_id1);
    // console.log("ID 2 : ",formData.veri_id2);




    // Handle change
    const handleChange = (e)=>{
        const { name, value } = e.target;
        setFormData(prevState => ({
          ...prevState,
          [name]: value
        }));
        validateField(name, value);
    };

    // Allowed file types
    const allowedImageTypes = ["image/jpeg", "image/png","image/webp" ];

    // Handling File Change
    const handleFileChange = (e)=>{
        const file = e.target.files[0];
        if (file) {
            const fileURL = URL.createObjectURL(file);
            setFormData((prev) => ({
              ...prev,
              fileName: file.name,
              filePreview: fileURL,
              file: file,
              imageKey: null // Reset image key when a new file is selected
            }));
            // console.log("Files : ",file);
            validateField("id",file.type);
        }
    }

    const handleFileChangeId1 = async(e)=>{
        try{
            setMiniImgLoad1(true);
            const file = e.target.files[0];
            if (file) {
                const fileURL = URL.createObjectURL(file);
                setFormData((prev) => ({
                    ...prev,
                    veri_id1 : "",
                    filePreviewId1: fileURL,
                    file1 : file,
                    imageKeyId1: "" // Reset image key when a new file is selected
                }));

                if (allowedImageTypes.includes(file.type)){
                    // console.log("Handle Change Upload")
                    let imageKeyData = await uploadImage(file);
                    console.log("Image Key : " + imageKeyData);
                    
                    setFormData(prevData => ({
                    ...prevData,imageKeyId1:imageKeyData,
                    veri_id1 : imageKeyData}));
                    // console.log("Form Data : " + JSON.stringify(formData));
                }
            }
            validateField("id1",file.type);
        }catch(error){
            console.log(error)
        }
        finally{
            setMiniImgLoad1(false);
        }
    }


    const handleFileChangeId2 = async(e)=>{
        try{
            setMiniImgLoad2(true);
            const file = e.target.files[0];
            if (file) {
                const fileURL = URL.createObjectURL(file);
                setFormData((prev) => ({
                    ...prev,
                    veri_id2 : "",
                    filePreviewId2: fileURL,
                    file2 : file,
                    imageKeyId2: "" // Reset image key when a new file is selected
                }));

                if (allowedImageTypes.includes(file.type)){
                    // console.log("Handle Change Upload")
                    let imageKeyData = await uploadImage(file);
                    console.log("Image Key : " + imageKeyData);
                    setFormData(prevData => ({
                    ...prevData,imageKeyId2:imageKeyData,
                    veri_id2 : imageKeyData}));
                    // console.log("Form Data : " + JSON.stringify(formData));
                }
            }
            validateField("id2",file.type);
        }catch(error){
            console.log(error)
        }
        finally{
            setMiniImgLoad2(false);
        }
    }


    // Country Code Change
    const handleCountryChange = (e) => {
        const newCode = e.target.value;
        setFormData(prevData => ({
          ...prevData,
          countryCode: newCode,
          phone: "" // Reset phone when country code changes
        }));
    };



    // Getting Country On Basis of Country Code  for Getting the Max Length
    const selectedCountry = countryCodeList.find(country => country.code === formData.countryCode);
    const maxLength = selectedCountry ? selectedCountry.length : 10;


    // Adding Validation to the Fields
    const validateField = (field,value)=>{

        const newErrors = {...errors};
        switch(field){
            case "name":
                if (value.trim() === "") {
                  newErrors.name = "Name is required";
                } 
                // else if (/\s/.test(value)) {
                //   newErrors.name = "Name cannot contain spaces";
                // } 
                else if (/\d/.test(value)) {
                  newErrors.name = "Name cannot contain digits";
                } else {
                  newErrors.name = "";
                }
                break;

            case "phone":
                if (value.trim() === "") {
                    newErrors.phone = "Phone number is required";
                } else if (value.length !== maxLength) {
                    newErrors.phone = `Phone number must be ${maxLength} digits`;
                } else if (!/^\d+$/.test(value)) {
                    newErrors.phone = "Phone number must contain only digits";
                } else {
                    newErrors.phone = "";
                }
                break;

            case "email":
                if (value.trim() === "") {
                    newErrors.email = "Email is required";
                } else if (!/^[\w-]+(\.[\w-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/.test(value)) {
                    newErrors.email = "Invalid email format";
                } else {
                    newErrors.email = "";
                }
                break;

            case "id":
                if(value.trim()===""){
                    newErrors.id = "Id is Required";
                }
                else if(!allowedImageTypes.includes(value)){
                    newErrors.id = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
                }
                else{
                    newErrors.id = ""
                }
                break;


            case "id1":
                if(value.trim()===""){
                    newErrors.id1 = "Id is Required";
                }
                else if(!allowedImageTypes.includes(value)){
                    newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
                }
                else{
                    newErrors.id1 = ""
                }
                break;


            case "id2":
                if(value.trim()===""){
                    newErrors.id2 = "Id is Required";
                }
                else if(!allowedImageTypes.includes(value)){
                    newErrors.id2 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
                }
                else{
                    newErrors.id2 = ""
                }
                break;

            default:
                break;
        }
        setErrors(newErrors);
    }

    // Validate Form 
    const validateForm =()=>{

        try{
            const newErrors = {};

            // Name
            if (!formData.name.trim()) {
                newErrors.name = "Name is required";
            } 
            // else if (/\s/.test(formData.name)) {
            //     newErrors.name = "Name cannot contain spaces";
            // } 
            else if (/\d/.test(formData.name)) {
                newErrors.name = "Name cannot contain digits";
            }

            // Phone
            if (!formData.phone.trim()) {
                newErrors.phone = "Phone number is required";
            } else if (formData.phone.length !== maxLength) {
                newErrors.phone = `Phone number must be ${maxLength} digits`;
            }

            // file
            // if (!formData.fileName) {
            //     newErrors.id = "ID is required";
            // }
            // if(formData.file){
            //     if (!allowedImageTypes.includes(formData.file.type)) {
            //     newErrors.id = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
            //     }
            // }

            // email
            if(!formData.email) {
                newErrors.email = "Email is required";
            }
            else if(!/^[\w-]+(\.[\w-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/.test(formData.email)){
                newErrors.email = "Invalid email format";
            }

            if(!formData.veri_id1){
                newErrors.id1 = "Front ID is required";
            }
            if(!formData.veri_id2){
                newErrors.id2 = "Back ID is required";
            }

            if(formData.file1){
                if (!allowedImageTypes.includes(formData.file1.type)) {
                    newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
                }
            }   
            if(formData.file2){
                if (!allowedImageTypes.includes(formData.file2.type)) {
                    newErrors.id1 = "Only images of Extension .jpg, .jpeg, .png, .webp are allowed";
                }
            }   

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;

        }catch(error){
            console.log(error);
        }

    }


    // Handle deleting the image
    // const handleDeleteImage = () => {
    //     // console.log("Delete Image");
    //     setFormData((prev) => ({
    //     ...prev,
    //     fileName: "",
    //     file: null,
    //     filePreview : "",
    //     }));
    //     setImageUrl("");
       
    //     document.getElementById("fileInput").value = ""; // Reset file input
    // };

    // Handle Delete Ids
    const handleDeleteId1 = ()=>{
        try{
            // console.log("Delete Image");
            setFormData((prev) => ({
                ...prev,
                veri_id1: "",
            }));
            setUrlId1("");

        }catch(error){
            console.log(error);
        }
    }

    const handleDeleteId2 = ()=>{
        try{
            // console.log("Delete Image");
            setFormData((prev) => ({
                ...prev,
                veri_id2: "",
            }));
            setUrlId2("");

        }catch(error){
            console.log(error);
        }
    }



    // Create a new Axios instance for uploads (without Authorization header)
    const uploadAxios = axios.create(); // This instance should not have any headers by default

    // Upload Image Function
    const uploadImage = async(file) =>{
        try{
            // Get the pre-signed URL for upload
            const response = await axiosInstance.get(
                `/api/v1/images/upload-presigned-url?file_name=${file.name}`
            );
      
            const { key, url } = response.data; // Extract key and URL from the response
  
            // console.log("Upload URL:", url); // Log the URL for debugging
            // console.log("File to upload:", file); // Log the file for debugging
        
            // Ensure no Authorization header is being sent
            uploadAxios.defaults.headers.common['Authorization'] = undefined; // Clear any Authorization headers
        
            // Use the uploadAxios instance to upload the file
            await uploadAxios.put(url, file, {
                headers: {
                "Content-Type": file.type, // Set the appropriate content type
                 token : localStorage.getItem("token") || ""
                },
            });
  
            return key;  // Return the uploaded image key

        }catch(error){
            console.log(error);
            toast.error("Some Error Occured While Uploading Imgae");
        }
    }



    // Handle Submit
    const handleSubmit = async()=>{
        try{
            // return;
            setLoading(true);
            if(!validateForm()){
                // console.log("Fix Errors Beform Submitting");
                return;
            }
            
            // console.log("ID1 : ",formData.veri_id1);
            // console.log("ID2 : ",formData.veri_id2);
            const verification_id = formData.veri_id1 + ',' + formData.veri_id2;
            // console.log("Verification ID:", verification_id);
            // let imageKey = formData.imageKey;
            // If there's a new file to upload
            // if (formData.file && !imageKey) {
            //     imageKey = await uploadImage(formData.file);
            //     // console.log("File Uploaded", imageKey);
            // }

            const countryCode = formData.countryCode;
            const contact =  countryCode.concat(formData.phone);
            const phone =  parseInt(contact,10);

            // Data To Be Submmmited
            const passData = {
                name: formData.name.trim(),
                email: formData.email.trim(),
                contact: phone,
                is_contact_verified: true,
                is_email_verified: true,
                verification_id: verification_id,
                address : formData.address
            };

            try{
                const response = await axiosInstance.put(`/api/v1/users/${userId}`,passData);
                
                // console.log("Updated User Profile : ",response.data);
                toast.success("User Profile Updated Successfully");
                localStorage.setItem("userName",formData.name)
                navigate("/bookings");
            }catch(error){
                toast.error(error.response.data.message);
                console.log(error);
            }

        }catch(erorr){
            console.log(erorr);
        }
        finally{
            setLoading(false);
        }
    }


    // Image View
    const handleImageView = async()=>{
        try{
            const downloadResponse = await axiosInstance.get(
            `/api/v1/images/download-presigned-url?key=${formData.fileName}`
            );
            const imageUrl = downloadResponse.data.url;
            // console.log("Image Url in Update to view",imageUrl)
            setImageUrl(imageUrl);
        }catch(error){
            console.log(error);
        }
    }

    // Toggle image modal
    const toggleImageModal = () => {
        setShowImageModal(!showImageModal);
    }


    const toggleImageModelId1 = ()=>{
        try{
            setImageModal1(!imageModal1);
        }catch(error){
            console.log(error);
        }
    }
    const toggleImageModelId2 = ()=>{
        try{
            setImageModal2(!imageModal2);
        }catch(error){
            console.log(error);
        }
    }


    // URL Generate For Old Id
    useEffect(()=>{
        const getImageData = async()=>{
            if(verification_id!==""){
                try{
                    setMiniImgLoad(true);
                    const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${verification_id}`);
                    const url = response.data.url;
                    setImageUrl(url);
                }catch(error){
                    console.log(error);
                }
                finally{
                    setMiniImgLoad(false)
                }
            }
        }
        getImageData();
    },[verification_id]);


    // Get URL for ID 1
    useEffect(()=>{
        const getImageData1 = async()=>{
            if(formData.veri_id1!==""){
                try{
                    setMiniImgLoad1(true);
                    const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${formData.veri_id1}`);
                    const url = response.data.url;
                    setUrlId1(url);
                }catch(error){
                    console.log(error);
                }
                finally{
                    setMiniImgLoad1(false);
                }
            }
        }
        getImageData1();
    },[formData.veri_id1])


    // Get URL for ID 2
    useEffect(()=>{
        const getImageData2 = async()=>{
            if(formData.veri_id2!==""){
                try{
                    setMiniImgLoad2(true);
                    const response = await axiosInstance.get(`/api/v1/images/download-presigned-url?key=${formData.veri_id2}`);
                    const url = response.data.url;
                    setUrlId2(url);
                }catch(error){
                    console.log(error);
                }
                finally{
                    setMiniImgLoad2(false);
                }
            }
        }
        getImageData2();
    },[formData.veri_id2])

 


  return (
    <>
        {loading && (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999 // Make sure the loader is on top
            }}>
                <PageLoader/>
            </div>
        )}
        <div className="editProfile">
            <Header title="Your Profile" />

            <div className="editProfile-data">

                {/* Name and title */}
                <div className="editProfile-fields">
                    <h4>Your name and title</h4>
                    <div className="editProfile-inps">
                        {/* <select>
                            <option>Mr.</option>
                            <option>Mrs.</option>
                        </select> */}
                        <input type="text" name="name" placeholder="Name" autoComplete='off' 
                        value={formData.name} onChange = {handleChange} />
                    </div>
                    {errors.name && <span className='error-message'>{errors.name}</span>}
                </div>
                
                {/* Phone */}
                <div className="editProfile-fields">
                    <h4>Phone</h4>
                    <div className="editProfile-phone">
                        <Dropdown
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleCountryChange}
                            placeholder="Country"
                            searchPlaceholder="Search country"
                            options={countryCodeList.map(country => ({
                                value: country.code,
                                label: `${country.name} (${country.code})`,
                            }))}
                        />
                        <input type="text" name="phone" autoComplete='off' placeholder="Enter Your Number"
                        value={formData.phone} onChange = {handleChange} maxLength= {maxLength}
                        />
                    </div>
                    {errors.phone && <span className="error-message">{errors.phone}</span>}
                </div>

                {/* Email */}
                <div className="editProfile-fields">
                    <h4>
                        Email
                    </h4>
                    <div className="editProfile-email">
                        <input type="email" name="email" placeholder='Email' autoComplete='off'
                        value={formData.email} onChange = {handleChange} />
                    </div>
                    {errors.email && <span className="error-message">{errors.email}</span>}
                </div>

                {/* Address */}
                <div className='editProfile-fields'>
                    <h4>Address</h4>
                    <div className='editProfile-address'>
                        <textarea name="address" value={formData?.address} onChange={(e)=>handleChange(e)}  rows="4" cols="10"></textarea>
                    </div>
                </div>

                {/* Upload Id */}
 

                {/* Uploaded Ids New */}
                <div className='userphoto-field'>
                    <div className='userphoto-field-title'>
                        <h4>Uploaded ID</h4>
                    </div>
                    {errors.id1 && <p className="error-message">{errors.id1}</p>}
                    {errors.id2 && <p className="error-message">{errors.id2}</p>}
                    {/* User Id Data  */}
                    <div className='user-ids-data'>
 
                        {
                            miniImgLoad1 ? (
                                <>
                                    <div className='editProfile-view2'>
                                        <div className='user-image-upload-skeleton2'></div>
                                    </div>
                                </>

                            ) :

                            formData.veri_id1 === "" ? (
                                <>
                                    <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                        id="fileInput1"
                                        onChange={(e)=>handleFileChangeId1(e)}
                                    />
                                    <label htmlFor="fileInput1" className="user-id-full">
                                        <div className="user-id-front">
                                            <h2>+</h2>
                                        </div>
                                        <div className="user-id-front-text">
                                            <h4>Front</h4>
                                        </div>
                                    </label>
                                </>
                            ) : (
                                <div className="user-id-full">
                                    <div
                                        className="user-id-front-bgimg"
                                        style={{
                                            backgroundImage: `url(${urlId1})`,
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                        }}
                                    >
                                        <div className="user-id-front-view-remove">
                                            <img src={eyeIcon} alt="View" onClick={()=>toggleImageModelId1()}   />
                                            <img src={deleteIcon} alt="Delete" onClick = {()=>handleDeleteId1()}  />
                                        </div>
                                    </div>
                                    <div className="user-id-front-text">
                                        <h4>Front</h4>
                                    </div>
                                </div>
                            )
                        }



                        {
                            miniImgLoad2 ? (
                                <>
                                    <div className='editProfile-view2'>
                                        <div className='user-image-upload-skeleton2'></div>
                                    </div>
                                </>

                            ) :

                            formData.veri_id2 === "" ? (
                                <>
                                    <input
                                        type="file"
                                        style={{ display: 'none' }}
                                        accept="image/*"
                                        id="fileInput2"
                                        onChange={(e)=>handleFileChangeId2(e)}
                                    />
                                    <label htmlFor="fileInput2" className="user-id-full">
                                        <div className="user-id-front">
                                            <h2>+</h2>
                                        </div>
                                        <div className="user-id-front-text">
                                            <h4>Back</h4>
                                        </div>
                                    </label>
                                </>
                            ) : (
                                <div className="user-id-full">
                                    <div
                                        className="user-id-front-bgimg"
                                        style={{
                                            backgroundImage: `url(${urlId2})`,
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat',
                                        }}
                                    >
                                        <div className="user-id-front-view-remove">
                                            <img src={eyeIcon} alt="View" onClick={()=>toggleImageModelId2()}   />
                                            <img src={deleteIcon} alt="Delete"  onClick = {()=>handleDeleteId2()}  />
                                        </div>
                                    </div>
                                    <div className="user-id-front-text">
                                        <h4>Back</h4>
                                    </div>
                                </div>
                            )
                        }

                    </div>
                </div>
                
            </div>



            {/* Save Changes Button */}
            <div className='editProfile-view-btn'>
                <button onClick={handleSubmit}>Save Changes</button>
            </div>


            {/* Image Modal */}
            {showImageModal && (
                <div className="image-modal">
                    <div className="modal-content">
                    <span className="close-btn" onClick={toggleImageModal}>
                        &times;
                    </span>
                    {formData.filePreview ? (
                        <Zoom>
                            <img src={formData.filePreview} alt="Uploaded Id"   />
                        </Zoom>
                    ) : (
                        imageurl ? (
                        <Zoom>
                            <img src={imageurl} alt="Uploaded Id"  />
                        </Zoom>
                        ) : (
                        <ImageLoader  />
                        )
                    )}
                    </div>
                </div>
            )}  

            {imageModal1 && (
                <div className="image-modal">
                    <div className="modal-content">
                        <span className="close-btn" onClick={()=>toggleImageModelId1()}>
                            &times;
                        </span>
                   
                        <Zoom>
                            <img src={urlId1} alt="Uploaded Id"   />
                        </Zoom>
                    </div>
                </div>
            )}

            {imageModal2 && (
                <div className="image-modal">
                    <div className="modal-content">
                        <span className="close-btn" onClick={()=>toggleImageModelId2()}>
                            &times;
                        </span>
                   
                        <Zoom>
                            <img src={urlId2} alt="Uploaded Id"   />
                        </Zoom>
                    </div>
                </div>
            )}



        
        </div>
    </>
  )
}
